/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import { generateClasses } from 'utils/generators';
import injectSheet from 'react-jss';
// styles
import styles from 'material/graphic/icon/icon_styles';
// import injectSheet from 'react-jss';
// import styles from 'material/graphic/icon/icon_styles';
// uses font awesome for iconography
// https://fontawesome.com/icons?d=gallery
// cdn stylesheet imported in app_styles


/* ========== ~~~~~~~~~~ ICON : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Icon = (props) => {
    return(
    	<span className={`icon name-${props.name} ${props.klass} ${generateClasses(props)} ${props.classes.icon} space-${props.space}`}>
    		<i className={`${props.style ? props.style : 'fas'} fa-${props.name} ${props.animation ? `fa-${props.animation}` : ''}`}/>
        </span>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Icon);
